export default __webpack_public_path__ + "static/media/134.09d8e152.svg";